import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Stack,
    Container,
    Checkbox,
  } from '@chakra-ui/react'
  import './RegisterModal.css';

  function RegisterModal({ isRegisterOpen, setIsRegisterOpen }) {
    const [inputVal, setInputVal] = useState({
      first_name:"",
      last_name:"",
      email:"",
      password:"",
      birthday:""
    })
    const [data, setData] = useState([]);

    const onClose = () => {
        setIsRegisterOpen(false);
    }

    const getData = (e) => {
      // console.log(e.target.value);

      const {value,name} = e.target;
      setInputVal(() => {
        return {
          ...inputVal,
          [name]:value
        }
        
      })
    }

    const addData = (e) => {
      e.preventDefault();
      const {first_name,last_name,email,password,birthday} = inputVal;
      if(first_name === ""){
        alert("first name field is required*")
      }else if(last_name === ""){
        alert("last name field is required*")
      }else if(email === ""){
        alert("email field is required*")
      }else if(!email.includes("@")){
        alert("Please enter a valid email")
      }else if(password === ""){
        alert("password field is required*")
      }else if(password.length < 8){
        alert("password  length must be greater then eight*")
      }else{
        localStorage.setItem("userRegister", JSON.stringify([...data,inputVal]));
      }
    }

    return (
      <>
        <Modal size='xl' isOpen={isRegisterOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
               <div style={{textAlign:'center', fontSize:'12px', backgroundColor:'#f5f5f5'}}>
                   <p>MYOOX</p> 
                   <p>REGISTRATION</p>
                   <p>Take advantage of a faster checkout and enjoy promotions for registered customers only</p>
                   <p>Discover all the benefits</p>
                </div>
                <div style={{width:'auto', margin:'auto',marginTop:'10px', textAlign:'center' }}>
                  <p>REGISTER WITH YOUR SOCIAL MEDIA ACCOUNT</p>
                </div>
                <Container w='sm'>
                  <Stack>
                  <Button colorScheme='facebook'> Facebook </Button>
                  <Button colorScheme='white' color='black' variant='outline'> Google </Button>
                  </Stack>
                  <div style={{textAlign:'center',marginTop:'10px', fontSize:'12px'}}>
                     <p>OR WITH YOUR EMAIL</p>
                  </div>
                  <Stack mt='10px'>
                    <input onChange={getData} name='first_name' className='first_name' type="text" placeholder='FIRST NAME*' />
                    <input onChange={getData} name='last_name' className='last_name' type="text" placeholder='LAST NAME*' />
                    <input onChange={getData} name='email' className='email' type="email" placeholder='E-MAIL*' />
                    <input onChange={getData} name='password' className='password' type="text" placeholder='PASSWORD*' />
                    <input onChange={getData} name="birthday" className='b_date' type="date"   />
                    <div style={{width:'auto', margin:'auto',marginTop:'10px', fontSize:"10px",  textAlign:'center' ,backgroundColor:'#f5f5f5'}}>
                      <p>I declare that I have read and accept the MYOOX Terms and Conditions of Use</p>
                    </div>
                    <div style={{padding:"0px",margin:'0px', marginTop:'10px',backgroundColor:'#f5f5f5'}}>
                    <Checkbox defaultChecked value='naruto'> <i style={{color:"gray",padding:"0px", fontSize:'10px'}}> 	I agree to the use of my personal data in order to be updated on new arrivals, informed about exclusive items and contacted as part of targeted marketing initiatives related to services offered by YOOX.
                          By analyzing my personal data, order history and browsing habits, YOOX can improve my shopping experience with suggestions that correspond to my interests.
                          For further information, please consult the Privacy Policy. </i> 
                    </Checkbox>
                    </div>
                    <Button onClick={addData} colorScheme='blue'> Submit </Button>
                  </Stack>
                  
                </Container>
             
            </ModalBody>

            <ModalFooter>
              
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }

  export default RegisterModal;